<template>
    <div>
        <van-dialog v-model="repealShow" :showConfirmButton='false'>
            <div>
                <div class="dialog-mian ben-align-center ben-000-color">
                    <p class="dia-title ben-size-18 ben-text-bold">{{repealComData.title}}</p>
                    <p class="dia-comm ben-size-14">{{repealComData.text}}</p>
                    <span v-if="repealComData.type=='repeal'" class="ben-c41335-color ben-size-14">(仅剩{{repealComData.count}}次报价机会)</span>
                </div>
                <div class="dia-btn">
                    <van-row type="flex" justify="end">
                        <van-col span="11" class="ben-align-center">
                            <button class="ben-btn-w" @click="repeal('yes')">确定</button>
                        </van-col>
                        <van-col span="11" offset="2" class="ben-align-center">
                            <button class="ben-btn-r" @click="repeal('no')">取消</button>
                        </van-col>
                    </van-row>
                </div>
            </div>
        </van-dialog>
    </div>
</template>
<script>
import "./../assets/index.css"
export default {
    name:'',
    props : {
        repealShow : {
            type : Boolean,
            default : false
        },
        clickOfferData:{
            type:Object
        },
        repealComData :{
            type: Object,
            default:{
                 type : "",
                title : "",
                text : ""
            }
        }
    },
    components: {
    },
    data () {
        return {
        }
    },
    created () {
        
    },
    methods: {
        repeal(val){
            if(val=="yes"){
                if(this.repealComData.type=="repeal"){//撤销
                    this.$emit("repealBtn",JSON.stringify(this.clickOfferData))
                }else{
                    this.$emit("delBtn",JSON.stringify(this.clickOfferData))
                }
            }else{
                this.$emit("noneRepeal")
            }
            
        }
    },
    mounted () {
        
    },
}

</script>


<style lang='scss' scoped>
.dia-btn{
    padding: 0 33px;
    margin-bottom: 40px;
    margin-top: 30px;
}
.dialog-mian{
    margin-top: 30px;
    .dia-comm{
        margin: 17px 0 0px 0;
    }
}
</style>


// WEBPACK FOOTER //
// src/view/procurement/components/repeal.vue